<template>
  <div>
    <div class="top"></div>
    <div class="main">
      <div class="head">
        <router-link to="/">
          <img src="../../assets/img/logo.png" alt=""
        /></router-link>
        <span> </span>
        <h6>「rakumart」があなたのアカウントを利用することを許可しますか?</h6>
      </div>
      <div class="content">
        <div class="box">
          <h5>この連携アプリを認証すると、次の動作が許可されます。</h5>
          <p>ユーザー名の共有およびRakumartへの自動注文が可能になります。</p>
          <!-- <h5>この連携アプリを認証しても、次の動作が許可されません。</h5>
          <p>パスワードを見る</p> -->
          <div class="login">
            <h6>ログイン</h6>
            <el-form
              :model="datas"
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <div class="label">Rakumartユーザー名</div>
              <el-form-item prop="username">
                <div class="input">
                  <el-input
                    v-model="datas.username"
                    placeholder="Rakumartユーザー名"
                  ></el-input>
                </div>
              </el-form-item>
              <div class="label">パスワード</div>
              <el-form-item prop="password">
                <div class="input">
                  <el-input
                    v-model="datas.password"
                    placeholder="パスワード"
                    type="password"
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <button @click="$router.go(-1)">キャンセル</button>
            <button
              style="background-color: #f3c622; margin-left: 10px"
              @click="authLogin"
            >
              アプリを認証する
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { authLogin } from "../../api/API/authorize";
export default {
  data() {
    return {
      datas: {
        username: "",
        password: "",
        client_id_hash: this.$route.query.client_id_hash,
        shop_hash: this.$route.query.shop_hash,
      },
      rules: {
        username: [
          {
            required: true,
            message: "ユーザー名を入力してください",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "暗証番号を入力してください",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    authLogin() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          authLogin(this.datas).then((res) => {
            console.log(res);
            if (!res.success)
              return this.$message(
                "認証失敗しました、担当者まだご連絡ください。"
              );
            this.$message.success("認証完了しました");
            setTimeout(() => {
              window.location.href = this.$route.query.redirect_uri;
            }, 1000);
          });
        }
      });
    },
  },
};
</script>
<style>
body {
  background-color: #f0f1f4;
  height: 100%;
}
</style>
<style lang='scss' scoped>
.top {
  height: 40px;
  background-color: #eee;
}
.main {
  width: 1000px;
  margin: 0 auto;
  .head {
    height: 140px;
    padding: 10px 0;
    overflow: hidden;
    span {
      float: left;
      width: 3px;
      height: 80px;
      background-color: #ccc;
      margin: 0 50px;
      margin-top: 15px;
    }
    img {
      float: left;
      width: 140px;
      height: 104px;
    }
    h6 {
      float: left;
      font-size: 22px;
      line-height: 104px;
    }
  }
  .content {
    .box {
      width: 500px;
      margin: 0 auto;
      background-color: #fff;
      padding: 50px 20px;
      h5 {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 25px;
      }
      p {
        text-indent: 2em;
        margin-bottom: 25px;
      }
      .login {
        padding: 20px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        /deep/.el-form-item__error {
          padding-left: 20px;
          font-size: 16px;
        }
        h6 {
          height: 45px;
          background-color: #f3c622;
          text-align: center;
          line-height: 45px;
          font-size: 20px;
          color: #fff;
          margin-bottom: 10px;
        }
        .label {
          padding: 0 20px;
          margin-bottom: 10px;
        }
        .input {
          padding: 0 20px;
          width: 90%;
          margin-bottom: 20px;
          /deep/.el-input__inner {
            border-color: #ccc;
          }
        }
      }
      .btn {
        margin-top: 20px;
        button {
          width: 49%;
          height: 48px;
          font-size: 18px;
          color: #fff;
          background-color: #c2c8d2;
          cursor: pointer;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>